import {SxProps} from '@mui/material';
import {Color, Font} from '~/constants/style';

export const styles: Record<string, SxProps> = {
  container: {
    backgroundColor: '#ffffff',
    border: '2px solid #f0f0f0',
    borderRadius: '8px',
    padding: {
      xs: '24px',
      sm: '32px',
    },
    marginBottom: '20px',
    width: '100%',
    maxWidth: '464px',
    minHeight: '320px',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    color: Color.Primary2Darkest,
    fontFamily: 'Lexend',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '24px',
    letterSpacing: '-0.75%',
    verticalAlign: 'middle',
    marginBottom: '16px',
  },
  detailContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    flex: 1,
  },
  row: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  label: {
    fontFamily: Font.Lexend,
    color: Color.Primary2Darkest,
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '18px',
    lineHeight: '22px',
    letterSpacing: '-0.75px',
    verticalAlign: 'bottom',
  },
  value: {
    color: Color.TextSecondary,
    fontFamily: Font.Lexend,
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '-0.75px',
    verticalAlign: 'bottom',
  },
};
